





















































































































export default function (Component) {
  Component.options.__source = "src/module/butler/views/components/cmp-joining-application-dialog.vue"
}
